export type DateTimeOption = { id: null | string, date: null | string, startTime: string | null, endTime: null | string }
export type ProgramBeingDeletedType = { date: string, startTime: string, endTime: string, specificProgram: string, id: string, attachments?: string[] }
export type ProgramBeingEditedType = { date: string, startTime: string, endTime: string, specificProgram: string, id: string, attachments?: string[] }
export type ProgramToBeSentFeedbackType = { date: string, startTime: string, endTime: string, specificProgram: string, id: string, attachments?: string[] }
export type MappedProgramType = {
  date: string;
  startTime: string;
  endTime: string;
  specificProgram: string;
  id: string;
  status: 'approved' | 'underApprovement';
  concat: string;
  attachments: string[];
}

export type ProgramAttachmentItem = {
  id: string;
  name: string;
  file?: File;
  url?: string;
}

export const MAX_PROGRAM_ATTACHMENTS = 5;

export type ListApiResponse = {
  success: boolean;
  activity: {
    nome: string,
    grade: {
      dia: 'seg' | 'ter' | 'qua' | 'qui' | 'sex',
      horarios: {
        horarioInicio: string,
        horarioTermino: string,
        vagas: number,
      }[] }[],
    datasDesabilitadas: string[],
    recorrente: boolean;
    specificPeriod: [Date, Date],
  };
  programs: {
    id: string;
    activityId: string;
    date: string;
    startTime: string;
    endTime: string;
    specificOrientation: string;
    status: 'approved' | 'underApprovement';
    attachments?: string[];
  }[]
}
